// Libellés des rôles utilisateurs (aligné backend).
export const USER_ROLE_LABEL = {
  gerant: 'Gérant',
  sommelier: 'Sommelier',
  serveur: 'Serveur',
};
